import { createContext, useEffect, useReducer } from "react";
import PropTypes from "prop-types";
// utils
import axios from "../helper/axiosIntance";
import { isValidToken, setSession, setInfoUser } from "../utils/jwt";
import jwtDecode from "jwt-decode";
import useAuth from "../hooks/useAuth";
// ----------------------------------------------------------------------

const initialState = {
    isAuthenticated: false,
    isInitialized: false,
    user: null,
};

const handlers = {
    INITIALIZE: (state, action) => {
        const { isAuthenticated, user } = action.payload;
        return {
            ...state,
            isAuthenticated,
            isInitialized: true,
            user,
        };
    },
    LOGIN: (state, action) => {
        const { user } = action.payload;

        return {
            ...state,
            isAuthenticated: true,
            user,
        };
    },
    LOGOUT: (state) => ({
        ...state,
        isAuthenticated: false,
        user: null,
    }),
    REGISTER: (state, action) => {
        const { user } = action.payload;

        return {
            ...state,
            isAuthenticated: true,
            user,
        };
    },
};

const reducer = (state, action) =>
    handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext({
    ...initialState,
    method: "jwt",
    login: () => Promise.resolve(),
    logout: () => Promise.resolve(),
    register: () => Promise.resolve(),
});

AuthProvider.propTypes = {
    children: PropTypes.node,
};

function AuthProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const { user } = useAuth();
    useEffect(() => {
        const initialize = async () => {
            try {
                const accessToken = window.localStorage.getItem("accessToken");

                if (accessToken && isValidToken(accessToken)) {
                    setSession(accessToken);
                    const response = await axios.post("/auth/api/info");
                    const user = JSON.parse(
                        window.localStorage.getItem("user")
                    );

                    dispatch({
                        type: "INITIALIZE",
                        payload: {
                            isAuthenticated: true,
                            user,
                        },
                    });
                } else {
                    dispatch({
                        type: "INITIALIZE",
                        payload: {
                            isAuthenticated: false,
                            user: null,
                        },
                    });
                }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: "INITIALIZE",
                    payload: {
                        isAuthenticated: false,
                        user: null,
                    },
                });
            }
        };
        initialize();
    }, []);

    const login = async (email, password) => {
        const response = await axios.post("/auth/api/login", {
            email,
            password,
        });
        console.log(response.data.data);

        const day3004 = new Date(2024, 3, 30);
        const presentDay = new Date();

        if (presentDay <= day3004) {
            const infoNotification = JSON.parse(localStorage.getItem(email));

            if (!infoNotification) {
                localStorage.setItem(
                    email,
                    JSON.stringify({
                        24: false,
                        25: false,
                        26: false,
                        27: false,
                        28: false,
                        29: false,
                        30: false,
                    })
                );
            }
        }
        const { access_token } = response.data.data;
        const user = jwtDecode(access_token);
        setSession(access_token);
        setInfoUser(JSON.stringify(user));
        dispatch({
            type: "LOGIN",
            payload: {
                user,
            },
        });
    };
    const register = async (email, password, firstName, lastName) => {
        const response = await axios.post("/auth/api/register", {
            email,
            password,
            firstName,
            lastName,
        });
        const { accessToken, user } = response.data;
        window.localStorage.setItem("accessToken", accessToken);
        dispatch({
            type: "REGISTER",
            payload: {
                user,
            },
        });
    };

    const logout = async () => {
        setSession(null);
        window.localStorage.clear();
        dispatch({ type: "LOGOUT" });
    };
    const resetPassword = () => {};
    const updateProfile = () => {};
    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: "jwt",
                login,
                logout,
                register,
                resetPassword,
                updateProfile,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export { AuthContext, AuthProvider };
